<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $tc('refund', 1) }}</div>
      <div>
        <router-link
          class="btn-blue"
          :to="{ path: '/cinema-manager/edit-refund', query: { id: this.refundObject.scd_id }}"
        >{{ $t('edit') }}</router-link>
        <router-link class="btn-blue" to="refund">{{ $tc('refund', 1) }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('cinema', 1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ refundObject.cine_name }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('screens') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ refundObject.screen_name }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('movie', 1) }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ refundObject.movie_title }} ({{ refundObject.mf_name }}) ({{ refundObject.lang_name }}) {{ refundObject.rating }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('show') }}</div>
              <div
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ refundObject.ss_start_date | dateparse }} - {{ refundObject.ss_start_show_time }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('showCancelReason') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ refundObject.rr_reason }}</div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1 " class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ refundObject.created_by }}</span>
              </div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1 " class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ refundObject.created_at | dateparse }}</span>
              </div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1 " class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ refundObject.updated_by }}</span>
              </div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1 " class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ refundObject.updated_at | dateparse }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RefundService from "@/services/RefundService";
import MasterService from "@/services/MasterService";
export default {
  data() {
    return {
      login_user_role_id: null,
      refundObject: {
        cine_id: null,
        cine_name: "",
        movie_details_id: null,
        scd_id: null,
        scd_is_active: "Y",
        screen_id: null,
        screen_name: "",
        ss_id: null,
        ss_start_date: "",
        ss_start_show_time: "",
        updated_at: null,
        updated_by: null,
        created_at: null,
        created_by: null
      }

    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    if (id) {
      this.getRefundDetails(id);
      console.log("id :", id);
    } else {
      this.$router.go(-1);
    }
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  mounted() {},
  methods: {
    getRefundDetails: function(scd_id) {
      console.log("scd_id :", scd_id);
      RefundService.GetRefundById({ scd_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.refundObject = data.Records[0];
            Object.keys(this.refundObject).map(x => {
              if (x === "created_by") {
                this.getViewUsersDetails(this.refundObject[x], "created_by");
              } else if (x === "updated_by") {
                this.getViewUsersDetails(this.refundObject[x], "updated_by");
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getViewUsersDetails(user_id, fieldvalue) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.refundObject[fieldvalue] = data.Records[0].user_name;
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch(error => {
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    },
    goToRoute: function(path, item) {
      const { scd_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: scd_id
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/RefundComponents/viewRefund.vue